
import * as types from 'actions/action-types';

var initialState = {
    profile: null,
    profile_saved: null,
    profile_pending: false,
    profile_save_pending: false,
    profile_unsubscribe: false,

    profiles: null,
    profiles_saved: null,
    profiles_pending: false,
    profiles_save_pending: false,
    profiles_unsubscribe: false,
    profile_unsubscribe: false,

    vendors: null,
    vendors_pending: false,
    vendors_unsubscribe: false,
    
    address: null,
	address_pending: false,
	address_save_pending: false,
};

const ProfilesReducer = (state = initialState, action) => {

    switch (action.type) {
        case types.PROFILE + '_PENDING': pending('profile'); break;
        case types.PROFILE + '_SAVE_PENDING': save_pending('profile'); break;
        case types.PROFILE + '_SAVE_FULFILLED': save_fulfilled('profile'); break;
        case types.PROFILE + '_FULFILLED': fulfilled('profile'); break;
        case types.PROFILE + '_CLEAR': clear('profile', {}); break;

        case types.PROFILES + '_PENDING': pending('profiles'); break;
        case types.PROFILES + '_SAVE_PENDING': save_pending('profiles'); break;
        case types.PROFILES + '_SAVE_FULFILLED': save_fulfilled('profiles'); break;
        case types.PROFILES + '_FULFILLED': fulfilled('profiles'); break;
        case types.PROFILES + '_CLEAR': clear('profiles', {}); break;

        case types.VENDORS + '_PENDING': pending('vendors'); break;
        case types.VENDORS + '_FULFILLED': fulfilled('vendors'); break;

        case types.ADDRESS + '_PENDING': pending('address'); break;
		case types.ADDRESS + '_SAVE_PENDING': save_pending('address'); break;
		case types.ADDRESS + '_FULFILLED': fulfilled('address'); break;
		case types.ADDRESS + '_CLEAR': state = { ...state, address: {} }; break;

        default: break;
    }

    return state;

    function pending(table) {
        state = {
            ...state,
            [table + '_pending']: true,
        };
    }
    function save_pending(table) {
        state = {
            ...state,
            [table + '_save_pending']: true,
        };
    }
    function save_fulfilled(table) {
        state = {
            ...state,
            [table + '_saved']: action.data,
            [table + '_save_pending']: false,
        };
    }
    function fulfilled(table) {
        state = {
            ...state,
            [table]: action.data,
            [table + '_pending']: false,
            [table + '_save_pending']: false,
            [table + '_unsubscribe']: (action.unsubscribe) ? action.unsubscribe : state[table + '_unsubscribe'],
        };
    }
    function clear(table, value) {
        state = {
            ...state,
            [table]: value,
        };
    }
};
export default ProfilesReducer;


